
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbLogIntegracao extends AppService {
  abstract sincronizar();
  abstract deleteOlderLogsByTenant();
  abstract getAllLogs(filter: AppFilter): Observable<any>;
  abstract getStatusAsPromise();
}
